/* eslint-disable array-callback-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import TableGridWithFeatures from '../../../../../SharedModules/Table/TableGridWithFeatures';
import { tableHead } from './gridComponents/tableHead';
import {
  dispatchNMAccountDetails,
  dispatchValidateNmAccountNumber,
  getNMAccountDetails,
  setNMAccInSys,
  validateNmAccountNumber,
} from '../../store/actions';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DeleteActionRender from '../deleteActionRender';
import TextBoxRender from './gridComponents/TextBoxRender';
import { DELETE_NM_ERR } from '../../../../../SharedModules/Errors/constantMessageData';
import { tableGridHight330 } from '../../../../../SharedModules/CommonConstants/commonConstants';
import {
  checkQuarterValidation,
  handleScrollToEvent,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';

function NMAccountNumber(props) {
  const {
    setUpdateNMAccount,
    fullScreenView,
    setSuccessMessage,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    setFullScreenView,
    setErrorMessages,
    isReadOnly,
    isEnabledByRole,
  } = props;
  // dispatch function
  const dispatch = useDispatch();
  const payload = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmAccountNumber
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const nmAccInSys = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmAccInSys
  );
  const isValidDeleteNMAccountNo = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.isValidDeleteNMAccountNo
  );
  // variable deceleration
  const gridRef = React.useRef();
  const [gridApi, setGridApi] = React.useState(gridRef);
  const [columnApi, setColumnApi] = React.useState(null);
  const [nmAccountNumberGridList, SetNmAccountNumberGridList] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteData, setDeleteData] = useState();

  React.useEffect(() => {
    setFullScreenView(false);
    dispatch(dispatchValidateNmAccountNumber(''));
    if (!(payload?.length > 0)) {
      dispatch(getNMAccountDetails({}));
    }
  }, []);

  React.useEffect(() => {
    if (disabledSaveCancelBtn) {
      SetNmAccountNumberGridList(payload);
    }
  }, [disabledSaveCancelBtn]);

  React.useEffect(() => {
    if (payload && payload.length > 0) {
      SetNmAccountNumberGridList(payload);
      setUpdateNMAccount(payload);
    }
  }, [payload]);
  React.useEffect(() => {
    if (deleteData && isValidDeleteNMAccountNo) {
      if (
        !nmAccountNumberGridList?.filter((x) => {
          return x.updateRecord || x.deleteRecord;
        })?.length > 0
      ) {
        setDisabledSaveCancelBtn(true);
        dispatch(getNMAccountDetails({}));
      }
      setSuccessMessage([]);
      dispatch(dispatchValidateNmAccountNumber(''));
      handleScrollToEvent();
      const startQtr = deleteData?.node?.data?.nmAccountIdVO?.startQtr;
      setDeleteData('');
      setErrorMessages([`${DELETE_NM_ERR} ${startQtr}.`]);
    }
    if (isValidDeleteNMAccountNo === false && deleteData) {
      setSuccessMessage([]);
      setErrorMessages([]);
      dispatch(dispatchValidateNmAccountNumber(''));
      setDisabledSaveCancelBtn(false);
      const tempObj = nmAccountNumberGridList.map((item) => {
        if (item.id === deleteData.data?.id) {
          item.deleteRecord = true;
        }
        return item;
      });
      deleteData.api.applyTransaction({
        remove: [deleteData?.node?.data],
      });
      SetNmAccountNumberGridList(tempObj);
      setUpdateNMAccount(tempObj);
    }
  }, [isValidDeleteNMAccountNo]);
  const onGridReady = React.useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  // handing  full screen view function
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const handleAddNewRow = (e, data, colApi) => {
    setSuccessMessage([]);
    setErrorMessages([]);
    const tempObj = data
      ? [...data]
      : nmAccountNumberGridList
      ? [...nmAccountNumberGridList]
      : [];
    tempObj.unshift({
      nmAccountIdVO: {
        startQtr: '',
        fileType: '',
        accountNumber: '',
      },
      lastUpdateDt: `${moment(new Date()).format('MM/DD/yyyy')} 00:00`,
      lastUpdateUserId: logInUser || 'DRAMS',
      oldStartQtr: null,
      oldFileType: null,
      oldAccountNumber: null,
      deleteRecord: false,
      updateRecord: false,
      newRecord: true,
      startQtrErr: false,
      fileTypeErr: false,
      accountNumberErr: false,
      id: uuidv4(),
    });
    SetNmAccountNumberGridList(tempObj);
    setUpdateNMAccount(tempObj);
    dispatch(dispatchNMAccountDetails(tempObj));
    setDisabledSaveCancelBtn(false);
    if (data) {
      dispatch(dispatchNMAccountDetails(tempObj));
      dispatch(setNMAccInSys(!nmAccInSys));
    }
    if (columnApi) {
      columnApi.applyColumnState({
        state: [{ colId: 'nmAccountIdVO.startQtr', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }
    if (colApi) {
      colApi.applyColumnState({
        state: [{ colId: 'nmAccountIdVO.startQtr', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }
  };

  const handleDeleteRow = () => {
    dispatch(dispatchValidateNmAccountNumber(''));
    if (deleteData?.node?.data?.newRecord) {
      const newObj = [...nmAccountNumberGridList];
      if (newObj && newObj.length > 0) {
        const key = newObj.findIndex((item) => {
          return item.id === deleteData?.node?.data.id;
        });
        newObj.splice(key, 1);
        SetNmAccountNumberGridList(newObj);
        dispatch(dispatchNMAccountDetails(newObj));
      }
    } else if (
      deleteData?.node?.data?.nmAccountIdVO?.startQtr &&
      checkQuarterValidation(deleteData?.node?.data?.nmAccountIdVO?.startQtr)
    ) {
      dispatch(
        validateNmAccountNumber(deleteData?.node?.data?.nmAccountIdVO?.startQtr)
      );
    }
  };
  return (
    <>
      <SaveCancelPopup
        data-testid="handleDelete"
        open={deletePopup}
        title="Delete"
        moduleName="the selected NMAccountNumber"
        onConfim={() => {
          setDeletePopup(false);
          handleDeleteRow();
          setSuccessMessage([]);
          setErrorMessages([]);
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />
      <div x className="ag-theme-alpine">
        <TableGridWithFeatures
          ref={gridRef}
          onGridReady={onGridReady}
          setGridApi={setGridApi}
          gridHeight={fullScreenView ? '70vh' : tableGridHight330}
          rowData={nmAccountNumberGridList || []}
          columnDefs={tableHead}
          data-testid="onEditingStopped"
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          exportFile
          helpMessage=""
          hideColumnsInPdf={['action']}
          singleClickEdit
          suppressCellFocus
          navigateToNextCell={navigateToNextCell}
          fileName="nmAccountNumber"
          addTxt="Add Account"
          addAction={handleAddNewRow}
          disableAddAction={isReadOnly || !isEnabledByRole}
          enterMovesDown
          onCellFocused={onCellFocused}
          frameworkComponents={{
            ActionCellRender: (cellInfo) => {
              return (
                <DeleteActionRender
                  cellInfo={cellInfo}
                  setDeletePopup={setDeletePopup}
                  setDeleteData={setDeleteData}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
            StartQuarterTextBoxRender: (cellInfo) => {
              return (
                <TextBoxRender
                  {...cellInfo}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
            FileTypeTextBoxRender: (cellInfo) => {
              return (
                <TextBoxRender
                  {...cellInfo}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  setUpdateNMAccount={setUpdateNMAccount}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
            AccountNumberTextBoxRender: (cellInfo) => {
              return (
                <TextBoxRender
                  {...cellInfo}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  disabled={isReadOnly || !isEnabledByRole}
                />
              );
            },
          }}
        />
      </div>
    </>
  );
}
export default withRouter(NMAccountNumber);
